import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { SnackbarProvider } from 'notistack';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { EventBusProvider } from './services/provider/EventBusProvider';
import { AuthProvider as ServicesAuthProvider } from './services/provider/AuthProvider';
import store from './store';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <Provider store={store}>
      <SnackbarProvider maxSnack={3}>
        <ThemeCustomization>
          <AuthProvider>
            <ServicesAuthProvider>
              <EventBusProvider>
                <ToastProvider>
                  <ScrollTop>
                    <RouterProvider router={router} />
                  </ScrollTop>
                </ToastProvider>
              </EventBusProvider>
            </ServicesAuthProvider>
          </AuthProvider>
        </ThemeCustomization>
      </SnackbarProvider>
    </Provider>
  );
}
